import React from 'react';
import moment from 'moment';
import RenderingImage from '../../common/RenderingImage';

import './Post.less';

export default function NewsReadPost(props) {
  const { header, date, tags, content, imageId } = props
  
  return (
    <article className="news-post">
      <h3>{header}</h3>

      <div className="news-post-info">
        {date && (
          <span className="date">
            {moment(date).format('DD.MM.yyyy')}
          </span>
        )}

        {tags?.map((e, i) => (
          <span key={i}>
            {i > 0 && (
              <b
                style={{
                  paddingLeft: '8px',
                  paddingRight: '8px',
                }}
              >
                ·
              </b>
            )}
            {e.name}
          </span>
        ))}
      </div>

      {imageId && (
        <div className="news-post-image">
          <RenderingImage url={`/minioFiles/download/${imageId}`}/>
        </div>
      )}

      <div className="news-post-content">{content}</div>
    </article>
  );
}
